module.exports = __webpack_public_path__ + "static/img/bg-highlights-8.86b94671.png";